import { defineComponent as S, ref as V, useAttrs as T, computed as n, openBlock as d, createElementBlock as p, normalizeClass as $, unref as t, createElementVNode as x, mergeProps as N, renderSlot as u, createTextVNode as k, toDisplayString as A, createCommentVNode as B, createVNode as E, withCtx as M } from "vue";
import { InputVariant as l, getTextareaLabelStyleClasses as I, getInputFieldStyleClasses as F } from "./novoui-vuejs62.js";
import L from "./novoui-vuejs819.js";
const _ = ["value", "placeholder", "disabled"], w = {
  key: 0,
  class: "input-label"
}, j = /* @__PURE__ */ S({
  inheritAttrs: !1,
  __name: "NTextarea",
  props: {
    variant: { default: l.fill },
    assistiveText: {},
    errorMessage: {},
    modelValue: {},
    label: {},
    placeholder: {},
    invalid: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: [
    /**
     * The event emitted on input value change
     */
    "update:modelValue"
  ],
  setup(m, { expose: c, emit: v }) {
    const s = V();
    c({ textareaExposed: s });
    const { class: b, ...f } = T(), h = v, a = m, g = (e) => {
      const r = e.target;
      h("update:modelValue", r.value);
    }, y = n(() => I(a)), C = n(() => F(a.variant));
    return (e, r) => {
      var o, i;
      return d(), p("label", {
        class: $(["text-area", [y.value, t(b)]])
      }, [
        x("textarea", N(f, {
          class: [C.value],
          value: e.$props.modelValue,
          placeholder: (e.variant === t(l).fill || e.variant === t(l)["fill-light"]) && ((o = e.label) != null && o.trim() || e.$slots.label) ? "" : e.$props.placeholder,
          ref_key: "textareaExposed",
          ref: s,
          disabled: e.$props.disabled,
          onInput: g
        }), null, 16, _),
        (i = e.label) != null && i.trim() || e.$slots.labelSlot ? (d(), p("span", w, [
          u(e.$slots, "labelSlot", {}, () => [
            k(A(e.label), 1)
          ])
        ])) : B("", !0),
        E(L, {
          assistiveText: a.assistiveText,
          errorMessage: a.errorMessage,
          invalid: a.invalid
        }, {
          default: M(() => [
            u(e.$slots, "assistiveTextSlot")
          ]),
          _: 3
        }, 8, ["assistiveText", "errorMessage", "invalid"])
      ], 2);
    };
  }
});
export {
  j as default
};
